/** @format */

import React from "react";
import { setShowDeleteModal } from "../deleteModal/deleteModalSlice";
import { ReactComponent as Delete } from "bootstrap-icons/icons/trash.svg";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectIsEditable, selectIsEditing } from "../editable/editableSlice";
import { Alert } from "react-bootstrap";
import i18n from "../i18n/init";
import { Card } from "../resources/types";

type CardErrorBoundaryProps = {
  type: string;
  card: Card;
  //renderLegacyCard?: () => ReactElement,
  children: React.ReactElement;
  message?: React.ReactElement;
  id: string;
};

type CardErrorBoundaryState = {
  hasError: boolean;
};

export class CardErrorBoundary extends React.Component<
  CardErrorBoundaryProps,
  CardErrorBoundaryState
> {
  constructor(props: CardErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    console.warn(error);
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // componentDidCatch(error:Error, errorInfo:ErrorInfo) {
  //   // You can also log the error to an error reporting service
  //   logErrorToMyService(error, errorInfo)
  // }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      console.warn(i18n.t("Failed to load card", { type: this.props.type }));

      return (
        <Alert variant="danger" className="d-flex align-items-center">
          <div className="flex-grow-1">
            <Alert.Heading className="mb-0">
              {i18n.t("Failed to load card", { type: this.props.type })}.
            </Alert.Heading>
            {this.props.message}
          </div>
          <div className="flex-shrink-0">
            <DeleteFunction uuid={this.props.id} />
          </div>
        </Alert>
      );
    }

    return <>{this.props.children}</>;
  }
}

const DeleteFunction: React.FC<{ uuid: string }> = ({ uuid }) => {
  const isEditable = useAppSelector(selectIsEditable() && selectIsEditing());
  const dispatch = useAppDispatch();

  return (
    <>
      {isEditable && (
        <Delete
          role="button"
          title="Delete Card?"
          style={{ width: "20px", height: "20px", cursor: "pointer" }}
          className=" text-editing flex-shrink-0 ms-3"
          onClick={() =>
            dispatch(
              setShowDeleteModal({
                action: "card",
                itemId: uuid,
              }),
            )
          }
        />
      )}
    </>
  );
};
